/**
 * @file
 * Behaviors for the Carousel.
 */
/* eslint-disable max-len */

( function( Drupal, bootstrap ) {
	/**
	 * Setup and attach the Carousel behaviors.
	 *
	 * @type {Drupal~behavior}
	 */
	Drupal.behaviors.carousel = {
		attach() {
			const carouselContainers = document.querySelectorAll( '.carousel__container' );

			const resizeObserver = new ResizeObserver(
				( entries ) => {
					const uniqueTargets = entries
						.map( ( entry ) => entry.target )
						.filter( ( target, i, targets ) => targets.indexOf( target ) === i )
					;
					uniqueTargets.forEach(
						( target ) => {
							this.measureCaptionHeights( target );
						}
					);
				}
			);

			carouselContainers.forEach( ( carouselContainer ) => {
				// Extract captions to their own carousel.
				const imageCarouselEl = carouselContainer.querySelector( '.carousel__image-carousel' );
				const captionCarouselEl = carouselContainer.querySelector( '.carousel__caption-carousel' );
				const newCaptionContainer = captionCarouselEl.querySelector( '.carousel-inner' );
				const captions = Array.from( imageCarouselEl.querySelectorAll( '.carousel-caption' ) );

				captions.forEach( ( caption, i ) => {
					newCaptionContainer.appendChild( caption );
					caption.classList.add( 'carousel-item' );
					caption.classList.remove( 'carousel-caption' );

					if ( i === 0 ) {
						caption.classList.add( 'active' );
					}
				} );

				const imageCarousel = bootstrap.Carousel.getOrCreateInstance( imageCarouselEl );

				// Activate the caption carousel. We don't seem to need to save it to a
				// variable.
				new bootstrap.Carousel( captionCarouselEl );

				captionCarouselEl.addEventListener( 'slide.bs.carousel', ( e ) => {
					// Set the current slide in the text indicator.
					captionCarouselEl.querySelector( '.carousel__current-slide' ).textContent = e.to + 1;

					// Boolean for if we are moving by one slide.
					let isAdjacent = Math.abs( e.from - e.to ) === 1;

					// If we're moving from the first slide to the last or vice versa, we
					// must do logic to detect whether or not we are looping around by a
					// single step.
					if (
						Math.min( e.from, e.to ) === 0 && // If we are moving to/from the first slide...
						Math.max( e.from, e.to ) === captions.length - 1 && // ...and from/to the last slide...
						(
							// ...and we are moving the correct direction to loop around...
							( e.from < e.to && e.direction === 'right' ) ||
							( e.to < e.from && e.direction === 'left' )
						)
					) {
						// ...then this is an adjacent move after all.
						isAdjacent = true;
					}

					if ( ! isAdjacent ) {
						imageCarousel.to( e.to );
					} else if ( e.direction === 'right' ) {
						imageCarousel.prev();
					} else {
						imageCarousel.next();
					}
				} );

				this.measureCaptionHeights( captionCarouselEl );

				window.addEventListener( 'load', () => {
					this.measureCaptionHeights( captionCarouselEl );
				} );

				resizeObserver.observe( captionCarouselEl );
			} );
		},
		measureCaptionHeights( captionCarouselEl ) {
			const captions = Array.from( captionCarouselEl.querySelectorAll( '.carousel-item' ) );
			captionCarouselEl.classList.add( 'carousel--measure-slides' );
			const greatestCaptionHeight = captions.reduce(
				( cumu, cur ) => Math.max( cumu, cur.getBoundingClientRect().height ),
				0
			);
			captionCarouselEl.style.setProperty( '--caption-height', `${ greatestCaptionHeight }px` );
			captionCarouselEl.classList.remove( 'carousel--measure-slides' );
		},
	};
// eslint-disable-next-line no-undef
}( Drupal, bootstrap ) );
